import { InternalTaskInformationFormService } from './shared/internal-task-information.form.service';
import { Component, Input, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { BaseControl, Context, Static, Tarea, TareaBasic, Const } from '@app/shared';
import { InternalTaskInformationDataService } from './shared/internal-task-information.data.service';
import { TaskService } from '@app/shared/task/shared/task.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { BsModalRef } from 'ngx-bootstrap';
import { find } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/core';



@Component({
  selector: 'iw-internal-task-information',
  templateUrl: './internal-task-information.component.html',
  styleUrls: ['./internal-task-information.component.scss'],
  providers: [
    InternalTaskInformationDataService,
    InternalTaskInformationFormService
  ]
})


export class InternalTaskInformationComponent implements OnInit {
  // Datos de la tarea
  @Input() task: Tarea;
  // tipo del proceso de la tarea renderizada
  @Input() typeProcess: string;
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando es el titulo de una tarea de asignacion
  @Input() assignament = false;
  finishTask = false;
  // Variable que rompe la dependencia de objetos con la variable de entrada
  taskUtilities: Tarea;
  // define cuando mostrar el furmulario en el tap
  @Output() frmOpen: EventEmitter<boolean> = new EventEmitter();
  // control del formulario de edicion
  control: BaseControl<any>[];
  // Tareas refinadas
  TaskStatus: TareaBasic[];
  // Define si el usuario es responsable de la tarea
  userResponsible = false;
  // Define si la tarea está activa o no
  active_task: boolean = false;
  // define la posicion del tab
  tab = 'tab-info';
  // Define los tipos de permisos que tiene el usuario en sesión sobre la tarea
  activateAction = {
    tabTaskInfo: false,
    taskDocument: false,
    taskResponsible: false
  };
  // Referencia de la modal
  private modalRef: BsModalRef;
  @Output() modifyDocumentEmitter: EventEmitter<any> = new EventEmitter();

  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;


  constructor(
    private itifs: InternalTaskInformationFormService,
    private itids: InternalTaskInformationDataService,
    private as: AuthenticationService,
    private tds: TaskService,
    private ns: NotifierService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.taskUtilities = Static.copyObjet(this.task);
    this.active_task = this.task.activo;
    this.getStatus();
    this.activateAction.tabTaskInfo = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabTaskInternalInfo,
    );
    this.activateAction.taskDocument = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabTaskDocument,
    );
    this.activateAction.taskResponsible = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabTaskResponsible,
    );
    this.initializeTabs();
  }
  async getStatus() {
    this.TaskStatus = await this.tds.getStatusUtilities();
    this.TaskStatus.forEach(element => {
      element.nombre = element.nombre.charAt(0).toLocaleUpperCase() + element.nombre.slice(1);
    });
    this.formOpen();
  }

  initializeTabs() {
    if (this.activateAction.tabTaskInfo) {
      this.tab = 'tab-info';
    } else if (this.activateAction.taskDocument) {
      this.tab = 'tab-document';
    } else if (this.activateAction.taskResponsible) {
      this.tab = 'tab-responsible';
    }
  }

  formOpen() {
    this.control = this.itifs.getFields(
      this.taskUtilities,
      this.ngSelectTpl,
      this.TaskStatus
    );
  }

  sended(data: any) {
    if ((this.taskUtilities.fecha_registro == data.tPInicio || this.taskUtilities.fecha_finalizacion == data.tPFinal ||
      this.taskUtilities.tarea_estado == data.cboestado) && (this.taskUtilities.activo != data.chActivo)) {
      this.taskUtilities.activo = data.chActivo;
      if (this.taskUtilities.activo) {
        this.itids.taskUpdate(this.taskUtilities, 'activar');
      } else {
        this.itids.taskUpdate(this.taskUtilities, 'inactivar');
      }
      this.ns.set({
        source: 'task',
        eventTriggered: 'click',
        action: 'updateTask',
        instance: 'process',
        data: this.taskUtilities
      });
      this.frmOpen.emit(true);
    } else {
      this.taskUtilities.fecha_registro = data.tPInicio;
      this.taskUtilities.fecha_finalizacion = data.tPFinal;
      this.taskUtilities.tarea_estado = data.cboestado;
      this.taskUtilities.fecha_registro = data.tPInicio;
      let validSend = true;
      if (this.taskUtilities.tarea_estado) {
        let checkStatus = find(this.TaskStatus, { id: data.cboestado });
        if (checkStatus && checkStatus.nombre == "Finalizado" && !data.tPFinal) {
          validSend = false;
          this.toastr.warning('Es necesario registrar fecha de finalización dado que se ingreso el estado finalizado a la tarea', 'Información incompleta', { positionClass: 'toast-top-center' });
        } else if (checkStatus && checkStatus.nombre != "Finalizado" && data.tPFinal) {
          validSend = false;
          this.toastr.warning('Es necesario cambiar el estado de la tarea a finalizado dado que se ingreso fecha de finalización', 'Información incompleta', { positionClass: 'toast-top-center' });
        }
      }
      if (validSend) {
        this.itids.taskUpdate(this.taskUtilities, 'modificar_datos');
        this.ns.set({
          source: 'task',
          eventTriggered: 'click',
          action: 'updateTask',
          instance: 'process',
          data: this.taskUtilities
        });
        this.frmOpen.emit(true);
      }

    }


  }

  /**
     * Se procede a refrescar el flujo
     *
     * @memberof InternalTaskInformationComponent
     */
  formClose() {
    this.frmOpen.emit(true);
  }

  /**
   *Obtiene cambios cuando se abre la modal de stickers o documentos. Igual cuando se cierran
   *
   * @param {*} data
   * @memberof InternalTaskInformationComponent
   */
  modifyDocumentAction(data: any) {
    this.modifyDocumentEmitter.emit(data);
  }


  /**
    * Terminada la finalizacion de carga de datos se procede a refrescar el flujo
    *
    * @memberof InternalTaskInformationComponent
    */
  finishDataLoadRefresh() {
    this.modalRef.hide();
    this.event.emit({
      type: 'refreshFlow',
    });
    this.event.emit({
      type: 'closeForm',
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/internal-task-information.component.ts